// src/components/Store/ProductGallery.jsx
// Fotos de un producto (hasta 3): se deslizan con el dedo en móvil
// (scroll-snap nativo) y con flechas en desktop. Una sola foto = imagen fija.
import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

const ProductGallery = ({ images, alt, className = '' }) => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  if (images.length === 1) {
    return <img src={images[0]} alt={alt} loading="lazy" className={`w-full object-cover ${className}`} />;
  }

  const goTo = (i) => {
    const track = trackRef.current;
    if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  };

  const handleScroll = () => {
    const track = trackRef.current;
    if (track) setIndex(Math.round(track.scrollLeft / track.clientWidth));
  };

  const arrowClass =
    'absolute top-1/2 -translate-y-1/2 hidden sm:flex w-8 h-8 items-center justify-center rounded-full bg-white/90 text-[#3A2A20] shadow opacity-0 group-hover/gallery:opacity-100 transition-opacity disabled:!opacity-0';

  return (
    <div className={`group/gallery relative ${className}`}>
      <div
        ref={trackRef}
        onScroll={handleScroll}
        className="no-scrollbar flex h-full w-full snap-x snap-mandatory overflow-x-auto"
      >
        {images.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`${alt} (${i + 1}/${images.length})`}
            loading="lazy"
            className="h-full w-full shrink-0 snap-center object-cover"
          />
        ))}
      </div>

      <button
        type="button"
        onClick={() => goTo(index - 1)}
        disabled={index === 0}
        aria-label="Previous photo"
        className={`${arrowClass} left-2`}
      >
        <ChevronLeftIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => goTo(index + 1)}
        disabled={index === images.length - 1}
        aria-label="Next photo"
        className={`${arrowClass} right-2`}
      >
        <ChevronRightIcon className="h-4 w-4" />
      </button>

      <div className="pointer-events-none absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
        {images.map((src, i) => (
          <span
            key={src}
            className={`h-1.5 rounded-full bg-white shadow transition-all duration-200 ${
              i === index ? 'w-4' : 'w-1.5 opacity-60'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;
